export default {
  PATTERN: ['settings', 'description', 'switch', 'func', 'funcs'],
}
